import { Component } from '@angular/core';
import { ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'demo-upp-side-menu',
    templateUrl: './demo-upp-side-menu.html',
    styleUrls: ['../demo-common.scss', './demo-upp-side-menu.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemoUppSideMenuComponent {
    selected = 'products';

    OnAction(action: string){
        this.selected = action;
    }
}
